import Vue from 'vue'
import Moment from 'moment'
import Swal from 'sweetalert2'
import {Table, TableColumn, Select, Option} from 'element-ui'
import PPagination from '@/components/UIComponents/Pagination.vue'
import PSwitch from '@/components/UIComponents/Switch.vue'
import API from '@/services/API'
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

const converterParaReal = (valor) => `R$ ${valor.toFixed(2)}`
const converterData = (data) => Moment(data).format('DD/MM/YYYY')

const extratoCabecalho = (nome, dataAssinatura) => {
  return `<tr>
            <td class="titulo">Nome</td>
            <td>${nome}</td>
          </tr>
          <tr>
            <td class="titulo">Data da assinatura</td>
            <td>${converterData(dataAssinatura)}</td>
          </tr>
   `
}

const controller = {
  components: {
    PPagination,
    PSwitch
  },
  name: 'AdminCtrl',
  data () {
    return {
      fullscreenLoading: false,
      situacaoOpcoes: [{
        value: 'pago',
        label: 'Pago'
      }, {
        value: 'pendente',
        label: 'Pendente'
      }],
      situacao: '',
      loading: true,
      switches: {
        defaultOn: true,
        plainOn: true,
        withIconsOn: true
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      tableColumns: [
        {
          prop: 'usuario.nome',
          label: 'Nome Completo',
          minWidth: 90
        },
        {
          prop: 'usuario.email',
          label: 'Email',
          minWidth: 60
        },
        {
          prop: 'usuario.contato.telefone',
          label: 'Telefone',
          minWidth: 40
        },
        {
          prop: 'cupom.codigo',
          label: 'Cupom',
          minWidth: 40
        }
      ],
      tableData: []
    }
  },
  methods: {
    ir (name, id) {
      this.$router.push({
        name,
        params: {
          id
        }
      })
    },
    formataExtrato (nome, demonstrativo) {
      const titulo = '<h4>Extrato do Assinante</h4>'
      const tipo = 'info'
      const cabecalho = extratoCabecalho(nome, demonstrativo[0].dataAssinatura)
      const linhas = ['<tr><td><br></td></tr>']
      linhas.push('<tr class="titulo"><td>Data do Vencimento</td><td>Data do Pagamento</td><td>Valor</td></tr>')
      for (let linha of demonstrativo) {
        linhas.push(`
          <tr>
          <td>${converterData(linha.expiraEm)}</td>
          <td>${converterData(linha.dataPagamento)}</td>
          <td>${converterParaReal(linha.valor)}</td>
          </tr>
        `)
      }
      const tr = linhas.join('')
      const html = `
        <table class="extrato-table">
        ${cabecalho}
        ${tr}
        </table>
      `
      Swal({
        title: titulo,
        type: tipo,
        html,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: 'Ok'
      })
    },
    mostrarExtrato (assinatura) {
      this.fullscreenLoading = true;
      API.assinatura.extrato(assinatura.id).then((response) => {
        if (response.status !== 200) {
          return console.error(response)
        }
        this.fullscreenLoading = false

        if (response.data.demonstrativo.length === 0) {
          return Swal('Demonstativo', 'Não existe extrato para essa assinatura!', 'warning')
        }

        let nome = `${assinatura.usuario.nome} ${assinatura.usuario.sobrenome}`
        this.formataExtrato(nome, response.data.demonstrativo)
      })
    },
    pegarAssinaturas () {
      let that = this;
      API.assinatura.listar().then((response) => {
        if (response.status === 200 && response.data.assinaturas) {
          that.tableData = response.data.assinaturas;
        }
        that.loading = false;
      });
    },
    atualizarUsuario (usuario) {
      API.assinatura.atualizar(usuario.id, usuario.status).then((val) => {
        this.pegarAssinaturas()
      })
    },
    dataReal: function (data) {
      let mudaData = Moment(data, 'YYYY-MM-DD').toDate();
      let newDate = Moment(mudaData).format('DD/MM/YYYY');
      if (String(newDate) !== 'Invalid date') {
        return newDate
      } else {
        return ''
      }
    }
  },
  computed: {
    pagedData () {
      return this.tableData.slice(this.from, this.to)
    },
    queriedData () {
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length
        return this.pagedData
      }
      let result = this.tableData
        .filter((row) => {
          let isIncluded = false
          let rowValue = JSON.stringify(row)
          if (rowValue.includes && rowValue.includes(this.searchQuery)) {
            isIncluded = true
          }
          return isIncluded
        })
      this.pagination.total = result.length
      return result.slice(this.from, this.to)
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      this.pagination.total = this.tableData.length
      return this.tableData.length
    }
  },
  created () {
    this.pegarAssinaturas()
  }
}
export default controller



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Admin/AssinaturasCtrl.js